export default "__VITE_ASSET__af1ff4ab__"